import {createRouter, createWebHistory} from "vue-router";
// import Dashboard from "../views/Dashboard.vue";
import IndexDashboard from "../views/dashboard/index.vue";
import CustomersDashboard from "../views/dashboard/customers/index.vue";
import OrderPrintPhoto from "../views/dashboard/order/print-photo.vue";
import Tables from "../views/Tables.vue";
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import SigninOtp from "../views/SigninOtp.vue";
import fillProfile from "../views/dashboard/profile/fillProfile.vue";

import {useAuthStore} from "@/store/auth";


const routes = [
    {
        path: "/signin",
        name: "Signin",
        component: Signin,
        meta: {title: 'ورود به پنل کاربری', requiresAuth: false}
    },
    {
        path: "/signin-otp",
        name: "signin-otp",
        component: SigninOtp,
        meta: {title: 'ورود به پنل کاربری', requiresAuth: false}
    },
    {
        path: "/signup",
        name: "Signup",
        component: Signup,
        meta: {title: 'ورود به پنل کاربری', requiresAuth: false}
    },
    {
        path: "/fill-profile",
        name: "fill-profile",
        component: fillProfile,
        meta: {title: 'تکمیل اطلاعات حساب کاربری', requiresAuth: true}
    },
    {
        path: "/profile",
        name: "profile",
        component: Profile,
        meta: {title: 'پروفایل', requiresAuth: true}
    },
    {
        path: "/",
        name: "/",
        redirect: "/dashboard",
        meta: {title: 'داشبورد', requiresAuth: true}
    },
    {
        path: "/dashboard",
        name: "داشبورد",
        // redirect: "/dashboard",
        component: IndexDashboard,
        meta: {title: 'داشبورد', requiresAuth: true}
    },
    {
        path: "/dashboard/customers",
        name: "لیست کاربران",
        component: CustomersDashboard,
        meta: {title: 'لیست کاربران', requiresAuth: true}
    },
    {
        path: "/dashboard/order/print-photo",
        name: "order-print-photo-create",
        component: OrderPrintPhoto,
        meta: {title: 'ثبت سفارش چاپ عکس', requiresAuth: true}
    },
    {
        path: "/dashboard/order/print-photo/:id/edit",
        name: "order-print-photo-edit",
        component: OrderPrintPhoto,
        meta: {title: 'ویرایش سفارش چاپ عکس', requiresAuth: true}
    },
    {
        path: "/dashboard/order/print-photo/:id/show",
        name: "order-print-photo-show",
        component: OrderPrintPhoto,
        meta: {title: 'نمایش جزئیات سفارش چاپ عکس', requiresAuth: true}
    },
    {
        path: "/tables",
        name: "Tables",
        component: Tables,
    },
    {
        path: "/billing",
        name: "Billing",
        component: Billing,
    },
    {
        path: "/virtual-reality",
        name: "Virtual Reality",
        component: VirtualReality,
    },
    {
        path: "/rtl-page",
        name: "RTL",
        component: RTL,
    },


];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "active",
});

router.beforeEach(async (to, from, next) => {

    //set title
    document.title = to.meta.title || 'پنل لابیران';

    const authStore = useAuthStore();
    const isAuthenticated = authStore.isAuthenticated;

    //redirect to fill profile if step 1
    if(authStore.user?.step == 1 && to.name !== 'fill-profile' && isAuthenticated ) {
        //todo uncomment
        // next('/fill-profile');
    }

        if (to.meta.requiresAuth && !isAuthenticated) {
        try {
            if (!authStore.userFetched) {
                await authStore.fetchUser();
            }
            if (authStore.isAuthenticated) {
                next();
            } else {
                next('/signin-otp');
            }
        } catch (error) {
            console.error('Error fetching user:', error);
            next('/signin-otp');
        }
    } else {
        next();
    }
    //end check token

});


export default router;
